<div class="container-content">
    <div class="section-title">
        <h3>IMPORTER UNE TRAME</h3>
    </div>

    <!-- Body -->
    <div class="section-body">
        <div class="section-left">
            <mat-form-field appearance="outline">
                <mat-label class="custom-lable-select">Nom du fournisseur</mat-label>
                <mat-select [(value)]="selectedSupplier" placeholder="Choisir un fournisseur"
                    (selectionChange)="fetchProductByLogisticVariable(undefined, true)">
                    <mat-option disabled class="no-checkbox-option">
                        <div class="d-flex align-items-center gap-2">
                            <mat-icon>search</mat-icon>
                            <input matInput placeholder="Rechercher..." [(ngModel)]="keywordSearchSupplier"
                                (click)="$event.stopPropagation()" style="flex: 1"
                                (ngModelChange)="onSupplierFilterChange($event)" />
                        </div>
                    </mat-option>
                    <mat-option *ngFor="let supplier of filteredSupplier" [value]="supplier">
                        {{ supplier?.title }}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <div class="section-actions">
                <div class="section-actions-item">
                    <h5>Export de la trame VL:</h5>
                    <mat-form-field appearance="outline" class="w-100" [tooltipDisabled]="selectedProducts.length === 0"
                        [pTooltip]="getSelectedSuppliersTooltip()" pTooltipPosition="top">
                        <mat-label class="custom-lable-select">Articles sélectionnés</mat-label>
                        <mat-select [(value)]="selectedProducts" multiple>
                            <mat-select-trigger>
                                <ng-container *ngIf="selectedProducts?.length; else placeholder">
                                    <span *ngFor="let product of selectedProducts; let last = last">
                                        {{ product.referenceProduct }}{{ !last ? ', ' : '' }}
                                    </span>
                                </ng-container>
                                <ng-template #placeholder> Sélectionner un produit... </ng-template>
                            </mat-select-trigger>

                            <mat-option disabled class="no-checkbox-option">
                                <div class="d-flex align-items-center gap-2">
                                    <mat-checkbox [checked]="isAllSelected()" [indeterminate]="isIndeterminate()"
                                        (change)="toggleSelectAll($event)" (click)="$event.stopPropagation()">
                                    </mat-checkbox>
                                    <input matInput placeholder="Rechercher..." [(ngModel)]="keywordSearchProduct"
                                        (click)="$event.stopPropagation()" style="flex: 1" autofocus
                                        [disabled]="productByLogisticVariable.loading"
                                        (ngModelChange)="onProductFilterChange($event)" />
                                </div>
                            </mat-option>

                            <ng-container *ngIf="
                                    productByLogisticVariable.content.length > 0;
                                    else elseTemplateNoProduct
                                ">
                                <mat-option *ngFor="let product of productByLogisticVariable?.content" [value]="product"
                                    [pTooltip]="product.shortDescription | translateDynamicLanguage">
                                    {{ product.referenceProduct }} -
                                    {{ product.shortDescription | translateDynamicLanguage }}
                                </mat-option>
                            </ng-container>
                            <ng-template #elseTemplateNoProduct>
                                <mat-option disabled class="load-more-option">
                                    <div class="text-center w-100">
                                        <span>Aucun article trouvé</span>
                                    </div>
                                </mat-option>
                            </ng-template>

                            <!-- Load More -->
                            <!-- <mat-option
                                disabled
                                *ngIf="
                                    productByLogisticVariable.content.length <
                                    productByLogisticVariable.totalElements
                                "
                                class="load-more-option"
                                (click)="loadMoreSuppliers()"
                            >
                                <div class="text-center w-100">
                                    <ng-container
                                        *ngIf="productByLogisticVariable.loading; else showLoadMore"
                                    >
                                        <div fxLayout="row" fxLayoutAlign="center center">
                                            <mat-spinner diameter="20"></mat-spinner>
                                        </div>
                                    </ng-container>
                                    <ng-template #showLoadMore>
                                        <span style="color: #000000; cursor: pointer">
                                            <i class="pi pi-plus" style="font-size: 0.75rem"></i>

                                            Charger plus...
                                        </span>
                                    </ng-template>
                                </div>
                            </mat-option> -->
                        </mat-select>
                    </mat-form-field>

                    <div fxLayout="row" fxLayoutAlign="center center" class="mt-2">
                        <button mat-menu-item class="btn-action" class="btn-action custom-icon-btn"
                            (click)="exportTemplateLogistic()">
                            EXPORTER LA TRAME
                        </button>
                    </div>
                </div>

                <div class="section-actions-item">
                    <h5>Import de VL:</h5>
                    <mat-form-field appearance="outline" style="width: 100%" (click)="fileInput.click()">
                        <input matInput [value]="
                                selectedFileLogistic.fileName.length > 0
                                    ? selectedFileLogistic.fileName
                                    : 'SÉLECTIONNER LE FICHIER'
                            " placeholder="SÉLECTIONNER LE FICHIER" readonly class="file-input"
                            [pTooltip]="selectedFileLogistic.fileName" />
                    </mat-form-field>

                    <!-- Input file ẩn -->
                    <input #fileInput type="file" style="display: none" accept=".xlsx,.xls,.csv"
                        (change)="onFileSelected($event)" />

                    <div fxLayout="row" fxLayoutAlign="center center" class="mt-2">
                        <button mat-menu-item class="btn-action custom-icon-btn" (click)="uploadFileLogistic()">
                            CHARGER LA TRAME

                            <i *ngIf="dataValidate.loading" class="pi pi-spin pi-spinner"
                                style="font-size: 0.75rem; margin-left: 6px"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="section-right">
            <h6>Résultat de l'import</h6>
            <div class="result-import" *ngIf="dataValidate.data">
                <p class="description">
                    Le chargement de la trame <strong>Variable logistique</strong> est terminé
                </p>
                <!-- Number Error -->
                <div class="item-number-error">
                    <div *ngFor="let item of importSummaryArray" [ngClass]="item.type">
                        <span>{{ item.label }}:</span> {{ item.value }}
                    </div>
                </div>
                <!-- IGNOR ERRPR -->
                <div class="section-ignore" *ngIf="dataValidate.data.records.length > 0">
                    <!--   <h6>IGNORE</h6> -->
                    <div class="item-ignore">
                        <p *ngFor="let item of dataValidate.data?.records; let i = index" [ngClass]="item.type">
                            <ng-container *ngIf="item.type === 'IGNORED'; else elseTemplate">
                                <span>{{ i + 1 }}: IGNORE </span>
                            </ng-container>
                            <ng-template #elseTemplate>
                                <span>{{ item.type }}:[LIGNE: {{ item?.row ?? 0 }} - COLONNE:
                                    {{ item?.column ?? 0 }}] {{ item?.message ?? '' }}</span>
                            </ng-template>
                        </p>
                    </div>
                </div>

                <div class="action-import-trame">
                    <div fxLayout="row" fxLayoutAlign="center center">
                        <button mat-menu-item class="btn-export-error" (click)="downloadReport()">
                            <span>TÉLÉCHARGER LE RAPPORT</span>
                        </button>
                    </div>

                    <div fxLayout="row" fxLayoutAlign="center center">
                        <button [disabled]="isExecuting" mat-menu-item class="btn-import"
                            (click)="onWorkflowLogisticVariable()">
                            <span *ngIf="isExecuting">En cours d'exécution</span>
                            <span *ngIf="!isExecuting">IMPORTER LA TRAME</span>


                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<p-toast></p-toast>